/* eslint-disable react-refresh/only-export-components */
import { withSuspense } from '@/modules/global-components/ui/suspense/withSuspense';
import { lazy } from 'react';
import { Navigate } from 'react-router';

const ListMarketing = lazy(
  () => import('@/modules/marketing/leads-list/ListMarketing'),
);
const ListReviews = lazy(
  () => import('@/modules/marketing/reviews/list/ListReviews'),
);

const QueuesMarketing = lazy(
  () =>
    import('@/modules/settings/components/components/components/marketing/QueuesMarketing'),
);

export const marketingRoutes = [
  {
    path: 'marketing',
    children: [
      {
        path: 'leads',
        element: withSuspense(ListMarketing),
      },
      {
        path: 'showcase',
        element: withSuspense(QueuesMarketing),
      },
      {
        path: 'reviews',
        children: [
          {
            index: true,
            element: <Navigate to="list" replace />,
          },
          {
            path: 'list',
            element: withSuspense(ListReviews),
          },
        ],
      },
    ],
  },
];
